export const Plans = {
  ANNUAL: 'fffvipa',
  SEASONAL: 'fffvip',
  TRIAL: 'ffftrial',
};
